export class WorkingHourProof {
  /*
  * In the future, these views will have to be redone so
  * that they contain everything required and not have to
  * update hot every time you enter
  * This has not been done due to lack of time
  */
  created: any;
  constructor(
    public hash?: string,
    public userHash?: string,
    public userName?: string,
    public day?: number,
    public totalTime?: number,
    public editable?: boolean,
    public validated?: boolean,
    public proofHash?: string,
    public proofName?: string,
    public proofDescription?: string,
    public proofIsXPO?: boolean,
    public proofIsMED?: boolean,
    public proofIsCOA?: boolean,
    public proofIsOTR?: boolean
  ) { }

  clone() {
    return new WorkingHourProof(
      this.hash,
      this.userHash,
      this.userName,
      this.day,
      this.totalTime,
      this.editable,
      this.validated,
      this.proofHash,
      this.proofName,
      this.proofDescription,
      this.proofIsXPO,
      this.proofIsMED,
      this.proofIsCOA,
      this.proofIsOTR
    );
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/working-hour-proof.ts